import request from '@/libs/request'

// 猪场出栏记录 列表
export function pigOutListApi (data) {
  return request({
    url: `pigFarm/pigOut`,
    method: 'get',
    params: data
  })
}

// 猪场出栏记录 详情
export function pigOutDetailApi (id) {
  return request({
    url: `pigFarm/pigOut/` + id,
    method: 'get'
  })
}


// 猪场出栏记录 编辑/添加
export function pigOutSaveApi (data) {
  return request({
    url: `pigFarm/pigOut`,
    method: 'post',
    data: data
  })
}

// 猪场出栏记录 删除
export function pigOutDelApi (id) {
  return request({
    url: `pigFarm/pigOut/` + id,
    method: 'delete'
  })
}

// 猪场出栏溯源
export function pigOutTraceabilityCodeApi (id) {
  return request({
    url: `pigFarm/pigOutApi/traceabilityCode/` + id,
    method: 'get',
    responseType: 'blob',
  })
}

// 猪场出栏 切换溯源状态
export function pigOutChangeShowSourceApi (id) {
  return request({
    url: `pigFarm/pigOutApi/changeShowSource/` + id,
    method: 'post'
  })
}



